import { useEffect } from "react";
import { useState } from "react";

export function isFunction(functionToCheck) {
  return (
    functionToCheck && {}.toString.call(functionToCheck) === "[object Function]"
  );
}

export function printNumber(input) {
  let d = [
    { unit: " میلیون  ", start: 7, len: -1, isOptional: true },
    { unit: " هزار ", start: 4, len: 3, isOptional: true },
    { unit: "تومان", start: 1, len: 3, isOptional: false },
    { unit: "ریال", start: 0, len: 1, isOptional: true },
  ];

  let x = "";

  for (let i = 0; i < 4; i++) {
    x = x + getDescription(input, d[i]);
  }
  return x;
}

export function getDescription(x, d) {
  let y = getPrice(x);
  let price = getPrice(x);
  let num = Math.pow(10, d.start);

  y = (y - (y % num)) / num;

  let isStarted = false;
  if (d.len > 0) {
    let num = Math.pow(10, d.len);
    if (y > num) isStarted = true;
    y = y % num;
  }

  if (y > 0) {
    let re = y.toString() + " " + d.unit;
    if (isStarted) {
      re = " و " + re;
    }
    return re;
  }

  if (d.isOptional === false && price > 10) {
    return " " + d.unit;
  }

  return "";
}

export function getPrice(x) {
  if (typeof x === "undefined") return 0;

  if (x === null || x === "") return 0;

  x = fixNumbers(x);
  x = removeNonNumber(x);

  x = parseInt(x);

  return x;
}

export function printPrice(x) {
  if (typeof x == "undefined") return "";

  if (x === null || x === "") return "";

  x = fixNumbers(x);
  x = removeNonNumber(x);
  x = parseInt(x);

  if (isNaN(x)) return "0";

  return MytoLocaleString(x);
}

export function printPan(x) {
  if (typeof x == "undefined") return "";

  if (x === null || x === "") return "";

  x = fixNumbers(x);
  x = removeNonNumber(x);

  if (isNaN(x)) return "0";

  return addDashToPanCard(x);
}

export function getPan(x) {
  if (!x) return "";

  x = fixNumbers(x);
  x = removeNonNumber(x);
  if (x.length > 16) return x.slice(0, 16);
  return x;
}
export function addDashToPanCard(value) {
  // return value.replace(/[^0-9]/g, "").replace(/\W/gi, '').replace(/(.{4})/g, '$1-');

  let result = "";

  for (let i = 0; i < value.length; i++) {
    if (i >=16) break;

    if (i % 4 === 0 && i > 0) result = result + "-";

    result = result + value.charAt(i);
  }

  return result;
}

export function MytoLocaleString(s) {
  let s1 = s.toLocaleString();
  let p = new Number(Math.floor(s) + 0.1); // similar value but decimal
  let p1 = p.toLocaleString();
  let index;
  let point;
  for (index = p1.length - 1; index > 0; index--) {
    // find decimal point in dummy
    point = p1.charAt(index);
    if (point < "0" || point > "9") break;
  }
  if (index > 0) {
    index = s1.lastIndexOf(point); // find last point in string
    if (index > 0) s1 = s1.slice(0, index); // truncate decimal part

    return s1;
  }
  return "";
}

export function fixNumbers(str) {
  let persianNumbers = [
    /۰/g,
    /۱/g,
    /۲/g,
    /۳/g,
    /۴/g,
    /۵/g,
    /۶/g,
    /۷/g,
    /۸/g,
    /۹/g,
  ];
  let arabicNumbers = [
    /٠/g,
    /١/g,
    /٢/g,
    /٣/g,
    /٤/g,
    /٥/g,
    /٦/g,
    /٧/g,
    /٨/g,
    /٩/g,
  ];
  if (typeof str === "string") {
    for (let i = 0; i < 10; i++) {
      str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
    }
  }
  return str;
}

export function removeNonNumber(str) {
  if (typeof str === "string") {
    str = str.replace(/[^\x30-\x39]/g, "");
  }
  return str;
}
export const scrollToTop = () =>
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
export const useDebouncer = (value, delay) => {
  const [debouncerValue, setDebouncerValue] = useState(value);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncerValue(value);
    }, delay);

    return () => clearTimeout(timeout);
  }, [value]);

  return debouncerValue;
};

export const printNationalCode = (x) => {
  if (!x) return;
  if (x.length > 10) return x.slice(0, 10);
  x = fixNumbers(x);
  x = removeNonNumber(x);

  if (isNaN(x)) return "0";
  return x;
};
export const printMobileNum = (x) => {
  if (!x) return;
  x = fixNumbers(x);
  x = removeNonNumber(x);
  if (x.length > 11) return x.slice(0, 11);

  if (isNaN(x)) return "0";
  return x;
};
